import { render, staticRenderFns } from "./CustomRoute.vue?vue&type=template&id=766ae61c&"
import script from "./CustomRoute.vue?vue&type=script&lang=js&"
export * from "./CustomRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports